import { channelType } from "./transformer";

export const sendLinkedlnCode = (payload) => {
    return {
        type: `${channelType}.SEND_CODE`,
        payload: payload
    };
};

